import { Button } from '@/components/ui/button';
import heroImage from '@/assets/hero-law.jpg';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section id="home" className="relative h-screen flex items-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat animate-fade-in transition-all duration-1000 ease-out transform scale-105 hover:scale-100"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-primary/85 via-primary/75 to-primary/90 animate-fade-in"></div>
      </div>
      
      <div className="relative z-10 container mx-auto px-4 text-center text-hero-foreground flex items-center justify-center h-full">
        <div className="opacity-0 animate-fade-in" style={{ animationDelay: '0.5s', animationFillMode: 'forwards' }}>
          <Link to="/about" className="block">
            <img 
              src="/lovable-uploads/ecc6029e-7bf1-4bc9-b8a5-d4a887b51137.png" 
              alt="Freeman & Crown Equity Law Group" 
              className="mx-auto max-h-40 md:max-h-48 w-auto object-contain cursor-pointer"
            />
          </Link>
          <blockquote className="mt-8 text-hero-foreground/90 text-base md:text-xl font-medium font-rockwell italic max-w-2xl mx-auto">
            {['"', "Nobody", "can", "give", "you", "freedom.", "Nobody", "can", "give", "you", "equality", "or", "justice", "or", "anything.", "If", "you're", "a", "man,", "you", "take", "it.", '"'].map((word, index) => (
              <span 
                key={index} 
                className="opacity-0 animate-fade-in inline-block mr-1" 
                style={{ 
                  animationDelay: `${1 + index * 0.1}s`, 
                  animationFillMode: 'forwards' 
                }}
              >
                {word}
              </span>
            ))}
            <span className="ml-4 text-hero-foreground/70 text-base font-rockwell font-normal not-italic opacity-0 animate-fade-in" style={{ animationDelay: '3.4s', animationFillMode: 'forwards' }}>
              — Malcolm X
            </span>
          </blockquote>
        </div>
      </div>
      
      {/* Copyright line for home page */}
      <div className="absolute bottom-0 left-0 right-0 z-10 p-4">
        <div className="text-center text-sm text-hero-foreground/40 opacity-0 animate-fade-in" style={{ animationDelay: '3.8s', animationFillMode: 'forwards' }}>
          © 2026 Freeman & Crown Equity Trust. All Rights Reserved.
        </div>
      </div>
    </section>
  );
};

export default Hero;